module.exports = __webpack_public_path__ + "static/media/meinual.c7f3c1bc.png";